// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46fa55cb","389":"8d2f4270","436":"2f6a1b2d","453":"3154de31","455":"c9027bf0"}[chunkId] + ".chunk.js";
};